var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 23.875V27.375H20.75V23.875H18.125L22.5 19.5L26.875 23.875H24.25ZM28.9312 21.2762C28.3363 18.2662 25.685 16 22.5 16C19.9712 16 17.775 17.435 16.6812 19.5262C14.0475 19.815 12 22.0375 12 24.75C12 26.1424 12.5531 27.4777 13.5377 28.4623C14.5223 29.4469 15.8576 30 17.25 30H28.625C29.1995 30 29.7684 29.8868 30.2992 29.667C30.83 29.4471 31.3123 29.1248 31.7186 28.7186C32.1248 28.3123 32.4471 27.83 32.667 27.2992C32.8868 26.7684 33 26.1995 33 25.625C33 23.315 31.2062 21.4425 28.9312 21.2762Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.0fc3cefdec1934cc4798a6f2b7f0e83f.svg";
export { ForwardRef as ReactComponent };